import React from "react";
var __jsx = React.createElement;
import { Select } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { FILTER_SELECT_STYLES } from "./filter-control-styles";
/** Mantine single-select filter; disabled with a hint when it has no options. */
export function SelectFilter(_ref) {
  var _safeOptions$find;
  var label = _ref.label,
    options = _ref.options,
    value = _ref.value,
    onChange = _ref.onChange,
    testId = _ref.testId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var safeOptions = options.filter(function (option) {
    return option.value && option.label;
  });
  var hasOptions = safeOptions.length > 0;
  var selectedLabel = (_safeOptions$find = safeOptions.find(function (option) {
    return option.value === value;
  })) === null || _safeOptions$find === void 0 ? void 0 : _safeOptions$find.label;
  return /*#__PURE__*/React.createElement("div", {
    className: "w-48",
    title: selectedLabel
  }, /*#__PURE__*/React.createElement(Select, {
    size: "sm",
    placeholder: hasOptions ? label : t("no_options", {
      defaultValue: "No options"
    }),
    data: safeOptions,
    value: value,
    onChange: onChange,
    searchable: true,
    clearable: true,
    withinPortal: true,
    disabled: !hasOptions,
    nothingFound: t("no_options", {
      defaultValue: "No options"
    }),
    "data-testid": testId,
    styles: FILTER_SELECT_STYLES
  }));
}